import { Parser } from "@siteimprove/alfa-parser";
import { Comma } from "../../../../syntax/index.js";
import { Hint } from "./hint.js";
import { Stop } from "./stop.js";
const { pair, map, option, left, right, separatedList } = Parser;
export var Item;
(function (Item) {
    function resolve(resolver) {
        return (value) => value.resolve(resolver);
    }
    Item.resolve = resolve;
    // <linear-color-hint>? , <linear-color-stop>
    const parse = pair(option(left(Hint.parse, Comma.parse)), Stop.parse);
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-color-stop-list}
     */
    Item.parseList = map(pair(Stop.parse, right(Comma.parse, separatedList(parse, Comma.parse))), ([first, rest]) => {
        const items = [first];
        for (const [hint, stop] of rest) {
            items.push(...hint, stop);
        }
        return items;
    });
})(Item || (Item = {}));
//# sourceMappingURL=item.js.map